import {AnchorHTMLAttributes, FC} from 'react';
import clsx from 'clsx';
import Icon from 'components/Icon';
import i18next from 'i18next';

export type LinkProps = {
    isOpenInNewTab?: boolean;
} & AnchorHTMLAttributes<HTMLAnchorElement>;

const Link: FC<LinkProps> = ({
    children,
    className,
    isOpenInNewTab,
    ...rest
}) => (
    <a
        className={clsx('font-semibold inline-flex gap-1 items-center')}
        target={isOpenInNewTab ? '_blank' : undefined}
        {...rest}
    >
        {children}
        {isOpenInNewTab && (
            <Icon
                className={clsx(i18next.language === 'ja' && 'mr-1')}
                icon="open_blank"
                size="base"
            />
        )}
    </a>
);

export default Link;
